<template>
  <div id="app" ref='document'>
 




 
<router-view @setds='setds'  @ss='ss' :signedin='signedin' @setsignedin='setsignedin'  @setorder="setorder"  :products='products' :orderdetails='orderdetails' :wlgigs='wlgigs' :loaded='loaded'  :userdatas='userdatas' :datasstatus='datasstatus' :infoset='infoset' :userdataloaded='userdataloaded' :userinfo='userinfo' :infos='infos' :fav='fav'  :favall='favall'  :countrycode='countrycode' :wlgigobj='wlgigobj' :tokens='token' :allteam='allteam' :key="$route.fullPath" >
 </router-view>
 
 


  </div>
</template>

<script>
 
const fb = require('./firebase/firebaseconfig.js')

   var wlfav=[]
 import axios from 'axios'

export default {
  name: 'App',
      
 
  data () {

        return{
 

 products:[],
 wlgigs:[],
 token:null,
 loaded:false,
orderdetails:{},
signedin:false,
userdataloadeds:false,
infos:{},
userinfo:{},
userdatas:{},
datasstatus:false,
infoset:false,
countrycode:'India',
fav:[],
favall:[],
userdataloaded:false,
wlgigobj:{},
allteam:[]

}
     
    
  },
 async  created(){
 

 
fb.db.collection("wlframemainaccount")
    .onSnapshot((querySnapshot) => {
        var teams = [];
        querySnapshot.forEach((doc) => {
            teams.push(doc.data());
        });
  
        this.allteam=[
        ...teams
        ]
       
    });

 var vm=this
 if(fb.auth.currentUser!=null){


 var docRef = fb.db.collection("wlframeusers").doc(fb.auth.currentUser.uid);

docRef.onSnapshot((doc) => {
 

        vm.userinfo={
          ...doc.data(),
          id:doc.id
        }
        vm.userdataloaded=true

});
 }



  },
  mounted(){



 
 
} 
   ,
  computed:
  {

 

  },

   
  methods:{

etst(){
this.userdataloadeds=true
},
 setds(ss){
  alert('1')
 },
      
    ss(){
  alert('1')
 },
      
   
   setsignedin(bval){

 this.userinfo={
  ...bval[1]
 }
 this.userdataloaded=true
 

   },
 setorder(item){

  this.orderdetails={
    ...item
  }
 }

  }

}
</script>

<style>
 
</style>



// WEBPACK FOOTER //
// src/App.vue